import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/index.css';
import App from './App';
import { MsalAuthProvider, MeProvider } from './lib/auth';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './lib/theme';
import { FavoritesProvider } from './lib/favorites';
import { TasteSettingsProvider } from './lib/tasteSettings';
import { TasteMatchProvider } from './lib/tasteMatch';
import { DialogHost } from './lib/dialogs';
import { DateProofReviewProvider } from './lib/dateProofReview';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <MsalAuthProvider>
          <MeProvider>
            <BrowserRouter>
              <FavoritesProvider>
                <TasteSettingsProvider>
                  <TasteMatchProvider>
                    <DateProofReviewProvider>
                      <App />
                      <DialogHost />
                    </DateProofReviewProvider>
                  </TasteMatchProvider>
                </TasteSettingsProvider>
              </FavoritesProvider>
            </BrowserRouter>
          </MeProvider>
        </MsalAuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
